export default __webpack_public_path__ + "static/media/redux.0e4fb1c8.svg";